import { type HTMLAttributes, type Ref } from "react";

import { cn } from "../../lib/utils";

export interface ItemFooterProps extends HTMLAttributes<HTMLDivElement> {
  ref?: Ref<HTMLDivElement>;
}

export const ItemFooter = ({ className, ref, ...props }: ItemFooterProps) => (
  <div ref={ref} data-slot="item-footer" className={cn("flex basis-full items-center justify-between gap-2", className)} {...props} />
);
